module.exports = __webpack_public_path__ + "assets/a55dffee3050ccd83b0657fa577171aa.png";